'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DeckHeaderNormalMode = exports.DeckHeaderMinMode = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = require('react-bootstrap');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styles = {

    panel_heading: {
        padding: '8px 0px 12px',
        backgroundColor: '#770000',
        color: '#fff',
        marginRight: 0,
        marginLeft: 0,
        height: '35px'
    }
};

var DeckHeaderNormalMode = function (_Component) {
    _inherits(DeckHeaderNormalMode, _Component);

    function DeckHeaderNormalMode() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, DeckHeaderNormalMode);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DeckHeaderNormalMode.__proto__ || Object.getPrototypeOf(DeckHeaderNormalMode)).call.apply(_ref, [this].concat(args))), _this), _this.onMenuItemSelect = function (eventKey, event) {
            _this.props.onDeckMenuItemChange(eventKey);
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(DeckHeaderNormalMode, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var unreadMessageCount = null;
            // let self = this
            if (this.props.unreadMessageCount) {
                unreadMessageCount = _react2.default.createElement(
                    'span',
                    { 'data-toggle': 'tooltip', title: 'Unread Messages', className: 'badge bg-light-blue', style: { float: 'left' } },
                    this.props.unreadMessageCount
                );
            }

            var visitorOnlineStatus = this.props.visitorOnlineStatus ? _react2.default.createElement(
                'span',
                null,
                _react2.default.createElement('i', { className: 'fa fa-circle text-success', style: { paddingTop: '3px', paddingLeft: '5px' } })
            ) : _react2.default.createElement(
                'span',
                null,
                _react2.default.createElement('i', { style: { paddingTop: '3px', paddingLeft: '5px' }, className: 'fa fa-circle text-warning' })
            );

            var minMaxToggle = null;

            if (this.props.deckMode === "maximised") {
                minMaxToggle = _react2.default.createElement(
                    'a',
                    { href: '#', style: { marginLeft: '10px' } },
                    _react2.default.createElement('span', {
                        id: 'minim_chat_window',
                        className: 'fa icon_minim fa-chevron-down',
                        onClick: function onClick(e) {
                            e.preventDefault();
                            console.log("Minimise Button Clicked");
                            _this2.props.onMinimise();
                        }
                    })
                );
            } else if (this.props.deckMode === "minimised") {
                minMaxToggle = _react2.default.createElement(
                    'a',
                    { href: '#', style: { marginLeft: '10px' } },
                    _react2.default.createElement('span', {
                        id: 'maxim_chat_window',
                        className: 'fa fa-chevron-up icon_maxim',
                        onClick: function onClick(e) {
                            e.preventDefault();
                            console.log("Maximise Button Clicked");
                            _this2.props.onMaximise();
                        }
                    })
                );
            }

            return _react2.default.createElement(
                'div',
                { style: { width: '300px' } },
                _react2.default.createElement(
                    'div',
                    { style: styles.panel_heading },
                    _react2.default.createElement(
                        'div',
                        { style: { float: "left", paddingLeft: "5px", paddingTop: '3px' } },
                        _react2.default.createElement(
                            _reactBootstrap.Dropdown,
                            { id: 'dropdown-custom-menu', style: { zIndex: "9999999" } },
                            _react2.default.createElement(CustomToggle, { bsRole: 'toggle' }),
                            _react2.default.createElement(
                                _reactBootstrap.Dropdown.Menu,
                                { className: 'super-colors' },
                                _react2.default.createElement(
                                    _reactBootstrap.MenuItem,
                                    { eventKey: 'chat', onSelect: this.onMenuItemSelect },
                                    ' Chat'
                                ),
                                _react2.default.createElement(
                                    _reactBootstrap.MenuItem,
                                    { eventKey: 'visitorInfo', onSelect: this.onMenuItemSelect },
                                    ' Visitor Info'
                                ),
                                _react2.default.createElement(
                                    _reactBootstrap.MenuItem,
                                    { eventKey: 'contacts', onSelect: this.onMenuItemSelect },
                                    ' Contacts'
                                ),
                                _react2.default.createElement(
                                    _reactBootstrap.MenuItem,
                                    { eventKey: 'leaveMeeting', onSelect: this.onMenuItemSelect },
                                    ' Leave Chat'
                                ),
                                _react2.default.createElement(
                                    _reactBootstrap.MenuItem,
                                    { eventKey: 'endmeeting', onSelect: this.onMenuItemSelect },
                                    ' End Chat'
                                )
                            )
                        )
                    ),
                    unreadMessageCount,
                    _react2.default.createElement(
                        'div',
                        { className: 'col-xs-8 chatdiv', style: { paddingLeft: '4px', paddingTop: '0' } },
                        visitorOnlineStatus,
                        _react2.default.createElement(
                            'p',
                            { title: this.props.guestName, className: 'guestName', style: { float: 'left' } },
                            _react2.default.createElement(
                                'span',
                                null,
                                this.props.guestName
                            )
                        ),
                        _react2.default.createElement(
                            'span',
                            { style: { float: 'left' } },
                            '\xA0(',
                            this.props.meetingId,
                            ')'
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'col-xs-2 controliconsdiv', style: { paddingLeft: '3px', paddingRight: '11px', float: 'right', paddingTop: '3px' } },
                        _react2.default.createElement(
                            'div',
                            { className: 'controlicons', style: { float: 'right', display: 'block', color: '#fff' } },
                            minMaxToggle
                        )
                    )
                )
            );
        }
    }]);

    return DeckHeaderNormalMode;
}(_react.Component);

var DeckHeaderMinMode = function (_Component2) {
    _inherits(DeckHeaderMinMode, _Component2);

    function DeckHeaderMinMode() {
        _classCallCheck(this, DeckHeaderMinMode);

        return _possibleConstructorReturn(this, (DeckHeaderMinMode.__proto__ || Object.getPrototypeOf(DeckHeaderMinMode)).apply(this, arguments));
    }

    _createClass(DeckHeaderMinMode, [{
        key: 'render',
        value: function render() {
            var _this4 = this;

            var unreadMessageCount = null;
            // let self = this
            if (this.props.unreadMessageCount) {
                unreadMessageCount = _react2.default.createElement(
                    'span',
                    { id: 'unread-messages', 'data-toggle': 'tooltip', title: 'Unread Messages', className: 'badge bg-light-blue', style: { float: 'left' } },
                    this.props.unreadMessageCount
                );
            }
            return _react2.default.createElement(
                'div',
                { style: { width: '200px' } },
                _react2.default.createElement(
                    'div',
                    { style: styles.panel_heading },
                    _react2.default.createElement(
                        'div',
                        { className: 'col-xs-10 chatdiv', style: { paddingLeft: '4px', paddingTop: '1px' }, onClick: function onClick() {
                                _this4.props.moveToVisibleDecks();
                            } },
                        unreadMessageCount,
                        _react2.default.createElement(
                            'p',
                            { title: this.props.guestName, className: 'guestName', style: { float: 'left' } },
                            _react2.default.createElement(
                                'span',
                                null,
                                this.props.guestName
                            )
                        ),
                        _react2.default.createElement(
                            'span',
                            { style: { float: 'left' } },
                            '\xA0(',
                            this.props.meetingId,
                            ')'
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'col-xs-2 controliconsdiv', style: { paddingLeft: '3px', paddingRight: '11px', float: 'right' } },
                        _react2.default.createElement('div', { className: 'controlicons', style: { float: 'right', display: 'block', color: '#fff' } })
                    )
                )
            );
        }
    }]);

    return DeckHeaderMinMode;
}(_react.Component);

var CustomToggle = function (_React$Component) {
    _inherits(CustomToggle, _React$Component);

    function CustomToggle(props) {
        _classCallCheck(this, CustomToggle);

        var _this5 = _possibleConstructorReturn(this, (CustomToggle.__proto__ || Object.getPrototypeOf(CustomToggle)).call(this, props));

        _this5.handleClick = _this5.handleClick.bind(_this5);
        return _this5;
    }

    _createClass(CustomToggle, [{
        key: 'handleClick',
        value: function handleClick(e) {
            e.preventDefault();
            this.props.onClick(e);
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: 'btn-group' },
                _react2.default.createElement(
                    'a',
                    { href: '#', type: 'button', className: 'dropdown-toggle', 'data-toggle': 'dropdown', onClick: this.handleClick },
                    _react2.default.createElement('span', { className: 'fa fa-bars' })
                )
            );
        }
    }]);

    return CustomToggle;
}(_react2.default.Component);

exports.DeckHeaderMinMode = DeckHeaderMinMode;
exports.DeckHeaderNormalMode = DeckHeaderNormalMode;


// WEBPACK FOOTER //
// ../chat/lib/components/dock/deck_header.js